__turbopack_context__.v({
  "hidePrintResume": "ctKWGq_hidePrintResume",
  "printResume": "ctKWGq_printResume",
});
